// RETAIL TABEL VIEW ?
<template>
    <v-container fluid class="pt-0">
        <v-row align="start" justify="center">
            <v-col cols="12" md="12" sm="12">
                <v-card class="elevation-4">
                    <v-card-title>
                        Retail Item List
                        <div class="flex-grow-1"></div>
                        <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        ></v-text-field>
                        <v-btn color="primary" class="ml-3" @click="$router.push({name:'createretailitem'})">Create Retail Item</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-divider></v-divider>
                        <v-data-table
                            :headers="headers"
                            :items="idtypes"
                            :items-per-page="2000"
                            :search="search"
                            class="elevation-1">


                            <template v-slot:item.showonmenu="{ item }">
                                <div v-if="item.showonmenu==1 ">
                                        <v-switch  color="success" :input-value="shw" @click="updateshowitem(item.id,0)"  :id="'showonitem-'+item.id"></v-switch>
                                </div>
                                <div v-else>
                                    <v-switch  color="" :input-value="nshw" @click="updateshowitem(item.id,1)"  :id="'showonitem-'+item.id"></v-switch>

                                </div>
                            </template>

                            <template v-slot:item.fimage="{ item }">
                              <v-avatar @click="editItem(item)" class="eHover">
                                <img :src="item.fimage" :alt="item.name" />
                              </v-avatar>
                            </template>

                            <template v-slot:item.action="{ item }">
                                <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                                <v-icon small @click="deleteItem(item)">delete</v-icon>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script >
import Vue from 'vue'
export default
{
    data: () => ({
        shw:true,
        nshw:false,
        search: "",
        headers: [
            { text: "Image", value: "fimage", sortable: false },
            { text: "Name", value: "retailitemname" },
            { text: "Price", value: "price" },
            { text: "Show", value: "showonmenu" },
            { text: "Created At", value: "created_at" },
            { text: "Actions", value: "action", sortable: false }
        ],
        idtypes: [],
        business:[],
        business_id:0,
    }),
    created()
    {

        if(localStorage.getItem('business'))
        {
            this.business=JSON.parse(localStorage.getItem('business'));
            //fd.append('business_id',this.business['id']);
            this.business_id=this.business['id'];

        }
        else
        {


        }

      this.$http
      .get(this.$apidomain+"retailitemlistpwa/"+this.business_id)
      .then(res => {
       this.idtypes = res.data.retailitem;
      })
      .catch(err => {
        console.log(err.response);
      });
    },

    methods: {

        updateshowitem(id,showitem)
      {
         this.overlay=true;

        //  alert(id);

        //  let showitem=showitem;
         //showitem= document.getElementById('showonitem-'+itemid).value;

        // console.log('show item value ' + showitem+' itemid '+itemid);

            this.$http
            .post(this.$apidomain+"updateretailitemshow/"+id,{showitem:showitem})
            .then(res => {
                if(res.data.success==1)
                {

                        this.$http
                        .get(this.$apidomain+"retailitemlistpwa/"+this.business_id)
                        .then(res => {
                        this.idtypes = res.data.retailitem;
                        })
                        .catch(err => {
                            console.log(err.response);
                        });

                }



            })
            .catch(err => {
                console.log(err.response);
                this.overlay=false;

            });

      },
        editItem(item){
            this.$router.push({name:'editretailitem',params:{id:item.id}});
        },
        deleteItem(item)
        {
            if (confirm("Are you sure you want to delete this Retail Item?"))
            {
                this.$http
                .post(this.$apidomain+"deleteretailItem/"+item.id)
                .then(res => {

                        this.$http
                        .get(this.$apidomain+"retailitemlistpwa/"+this.business_id)
                        .then(res => {
                        this.idtypes = res.data.retailitem;
                        })
                        .catch(err => {
                            console.log(err.response);
                        });

                })
                    .catch(err => {
                            console.log(err.response);
                    });
            }
        },
    }
}

</script>
